import React, { FC } from 'react';
import { FormControl, FormHelperText, InputLabel, Select } from '@material-ui/core';

const dealStatus = [
  { id: 'win', label: 'Gagné' },
  { id: 'lost', label: 'Perdu' },
  { id: 'negotiation', label: 'En négociation' },
];

interface Props {
  className?: any;
  error?: boolean;
  helperText?: string;
  value?: string;
  size?: 'small' | 'medium';
  onChange: (event: React.ChangeEvent<{ name?: string; value: unknown }>) => void;
}

const StatusSelect: FC<Props> = ({ className, size = 'medium', value, onChange, helperText, error }) => {
  return (
    <FormControl size={size} variant='outlined' className={className} error={error}>
      <InputLabel>Statut</InputLabel>
      <Select native onChange={onChange} value={value} label='Statut'>
        <option value='' />
        {dealStatus.map((status, key) => (
          <option key={key} value={status.id}>
            {status.label}
          </option>
        ))}
      </Select>

      {helperText && <FormHelperText>{helperText}</FormHelperText>}
    </FormControl>
  );
};

export default StatusSelect;
